<template>
  <el-dialog
    :title="$t('editRechargeSetting.title')"
    :visible.sync="dialogVisible"
    width="600px"
    :close-on-click-modal="false">
    <el-form :model="editRechargeSettingForm" label-width="100px" class="edit-form">
      <el-form-item 
        :label="$t('editRechargeSetting.rechargeType')" 
        prop="rechargeType"
        :rules="[
          { required: true, message: $t('editRechargeSetting.rechargeTypeRequired'), trigger: 'blur' }
        ]">
        <el-select 
          v-model="editRechargeSettingForm.rechargeType" 
          :placeholder="$t('editRechargeSetting.rechargeType')" 
          style="width: 100%"
          @change="onRechargeTypeChange">
          <el-option v-for="(item, index) in rechargeTypeOptions" :key="index" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item 
        :label="$t('editRechargeSetting.rechargeTypeName')" 
        prop="rechargeTypeName">
        <el-input 
          v-model="editRechargeSettingForm.rechargeTypeName" 
          :placeholder="$t('editRechargeSetting.rechargeTypeNamePlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('editRechargeSetting.notice')">
        <el-input 
          v-model="editRechargeSettingForm.notice" 
          :placeholder="$t('editRechargeSetting.noticePlaceholder')" 
          type="textarea"
          :rows="3" />
      </el-form-item>
      <el-form-item :label="$t('editRechargeSetting.amountList')">
        <div class="amount-list-container">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addAmountRow" style="margin-bottom: 10px;">
            {{ $t('editRechargeSetting.addAmount') }}
          </el-button>
          <el-table 
            :data="amountRows" 
            border 
            style="width: 100%;"
            :show-header="true">
            <el-table-column 
              :label="$t('editRechargeSetting.faceAmount')" 
              width="140">
              <template slot-scope="scope">
                <el-input 
                  v-model.number="scope.row.faceAmount" 
                  type="number"
                  :placeholder="$t('editRechargeSetting.faceAmountPlaceholder')"
                  :min="0.01"
                  :step="0.01"
                  style="width: 120px;" />
              </template>
            </el-table-column>
            <el-table-column 
              :label="$t('editRechargeSetting.discountAmount')" 
              width="140">
              <template slot-scope="scope">
                <el-input 
                  v-model.number="scope.row.discountAmount" 
                  type="number"
                  :placeholder="$t('editRechargeSetting.discountAmountPlaceholder')"
                  :min="0.01"
                  :step="0.01"
                  style="width: 120px;" />
              </template>
            </el-table-column>
            <el-table-column 
              :label="$t('rechargeSetting.operation')" 
              align="center">
              <template slot-scope="scope">
                <el-button 
                  type="danger" 
                  size="small" 
                  icon="el-icon-delete" 
                  @click="removeAmountRow(scope.$index)"
                  :disabled="amountRows.length <= 1">
                  {{ $t('rechargeSetting.delete') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="amount-tip">{{ $t('editRechargeSetting.amountListTip') }}</div>
        </div>
      </el-form-item>
      <el-form-item :label="$t('editRechargeSetting.fastAmountList')">
        <div class="amount-list-container">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addFastAmountRow" style="margin-bottom: 10px;">
            {{ $t('editRechargeSetting.addAmount') }}
          </el-button>
          <el-table 
            :data="fastAmountRows" 
            border 
            style="width: 100%;"
            :show-header="true">
            <el-table-column 
              :label="$t('editRechargeSetting.faceAmount')" 
              width="140">
              <template slot-scope="scope">
                <el-input 
                  v-model.number="scope.row.faceAmount" 
                  type="number"
                  :placeholder="$t('editRechargeSetting.faceAmountPlaceholder')"
                  :min="0.01"
                  :step="0.01"
                  style="width: 120px;" />
              </template>
            </el-table-column>
            <el-table-column 
              :label="$t('editRechargeSetting.discountAmount')" 
              width="140">
              <template slot-scope="scope">
                <el-input 
                  v-model.number="scope.row.discountAmount" 
                  type="number"
                  :placeholder="$t('editRechargeSetting.discountAmountPlaceholder')"
                  :min="0.01"
                  :step="0.01"
                  style="width: 120px;" />
              </template>
            </el-table-column>
            <el-table-column 
              :label="$t('rechargeSetting.operation')" 
              align="center">
              <template slot-scope="scope">
                <el-button 
                  type="danger" 
                  size="small" 
                  icon="el-icon-delete" 
                  @click="removeFastAmountRow(scope.$index)"
                  :disabled="fastAmountRows.length <= 1">
                  {{ $t('rechargeSetting.delete') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="amount-tip">{{ $t('editRechargeSetting.fastAmountListTip') }}</div>
        </div>
      </el-form-item>
      <el-form-item :label="$t('editRechargeSetting.lowTime')">
        <el-input 
          v-model="editRechargeSettingForm.lowTime" 
          :placeholder="$t('editRechargeSetting.lowTimePlaceholder')" 
          style="width: 100%;" />
      </el-form-item>
      <el-form-item :label="$t('editRechargeSetting.fastTime')">
        <el-input 
          v-model="editRechargeSettingForm.fastTime" 
          :placeholder="$t('editRechargeSetting.fastTimePlaceholder')" 
          style="width: 100%;" />
      </el-form-item>
      <!-- <el-form-item :label="$t('editRechargeSetting.discountRate')">
        <el-input 
          v-model="editRechargeSettingForm.discountRate" 
          :placeholder="$t('editRechargeSetting.discountRatePlaceholder')" 
          type="number"
          step="0.01"
          min="0"
          max="1" />
        <span style="color: #666; font-size: 12px;">{{ $t('editRechargeSetting.discountRateTip') }}</span>
      </el-form-item> -->
      <el-form-item :label="$t('editRechargeSetting.remark')">
        <el-input 
          v-model="editRechargeSettingForm.remark" 
          :placeholder="$t('editRechargeSetting.remarkPlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('editRechargeSetting.sort')">
        <el-input 
          v-model="editRechargeSettingForm.sort" 
          :placeholder="$t('editRechargeSetting.sortPlaceholder')" 
          type="number" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t('editRechargeSetting.cancel') }}</el-button>
      <el-button type="primary" @click="save">{{ $t('editRechargeSetting.save') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateRechargeSetting } from '@/api/admin/rechargeSettingApi'

export default {
  name: 'EditRechargeSetting',
  data() {
    return {
      dialogVisible: false,
      rechargeTypeOptions: [
        { label: this.$t('rechargeSetting.PHONE'), value: 'PHONE' },
        { label: this.$t('rechargeSetting.ELECTRIC'), value: 'ELECTRIC' },
        { label: this.$t('rechargeSetting.WATER'), value: 'WATER' },
        { label: this.$t('rechargeSetting.GAS'), value: 'GAS' },
        { label: this.$t('rechargeSetting.PROPERTY'), value: 'PROPERTY' }
      ],
      rechargeTypeNameMap: {
        'PHONE': this.$t('rechargeSetting.PHONE') + '充值',
        'ELECTRIC': this.$t('rechargeSetting.ELECTRIC') + '充值',
        'WATER': this.$t('rechargeSetting.WATER') + '充值',
        'GAS': this.$t('rechargeSetting.GAS') + '充值',
        'PROPERTY': this.$t('rechargeSetting.PROPERTY') + '充值'
      },
      editRechargeSettingForm: {
        id: '',
        rechargeType: '',
        rechargeTypeName: '',
        notice: '',
        amountList: '',
        fastAmountList: '',
        lowTime: '',
        fastTime: '',
        discountRate: '',
        remark: '',
        sort: 1
      },
      amountRows: [],
      fastAmountRows: []
    }
  },
  methods: {
    open(rechargeSetting) {
      this.dialogVisible = true
      this.editRechargeSettingForm = {
        id: rechargeSetting.id,
        rechargeType: rechargeSetting.rechargeType,
        rechargeTypeName: rechargeSetting.rechargeTypeName || '',
        notice: rechargeSetting.notice || '',
        amountList: rechargeSetting.amountList || '',
        fastAmountList: rechargeSetting.fastAmountList || '',
        lowTime: rechargeSetting.lowTime || '',
        fastTime: rechargeSetting.fastTime || '',
        discountRate: rechargeSetting.discountRate || '',
        remark: rechargeSetting.remark || '',
        sort: rechargeSetting.sort || 1
      }
      this.parseAmountList(rechargeSetting.amountList || '')
      this.parseFastAmountList(rechargeSetting.fastAmountList || '')
    },
    close() {
      this.dialogVisible = false
    },
    onRechargeTypeChange() {
      if (this.editRechargeSettingForm.rechargeType && !this.editRechargeSettingForm.rechargeTypeName) {
        this.editRechargeSettingForm.rechargeTypeName = this.rechargeTypeNameMap[this.editRechargeSettingForm.rechargeType]
      }
    },
    parseAmountList(amountList) {
      if (!amountList) {
        this.amountRows = [{ discountAmount: '', faceAmount: '' }]
        return
      }
      const pairs = amountList.split(',')
      this.amountRows = pairs.map(pair => {
        const [faceAmount, discountAmount] = pair.split(':')
        return {
          discountAmount: discountAmount ? Number(discountAmount) : '',
          faceAmount: faceAmount ? Number(faceAmount) : ''
        }
      })
      if (this.amountRows.length === 0) {
        this.amountRows = [{ discountAmount: '', faceAmount: '' }]
      }
    },
    parseFastAmountList(fastAmountList) {
      if (!fastAmountList) {
        this.fastAmountRows = [{ discountAmount: '', faceAmount: '' }]
        return
      }
      const pairs = fastAmountList.split(',')
      this.fastAmountRows = pairs.map(pair => {
        const [faceAmount, discountAmount] = pair.split(':')
        return {
          discountAmount: discountAmount ? Number(discountAmount) : '',
          faceAmount: faceAmount ? Number(faceAmount) : ''
        }
      })
      if (this.fastAmountRows.length === 0) {
        this.fastAmountRows = [{ discountAmount: '', faceAmount: '' }]
      }
    },
    addAmountRow() {
      this.amountRows.push({ discountAmount: '', faceAmount: '' })
    },
    removeAmountRow(index) {
      if (this.amountRows.length > 1) {
        this.amountRows.splice(index, 1)
      }
    },
    addFastAmountRow() {
      this.fastAmountRows.push({ discountAmount: '', faceAmount: '' })
    },
    removeFastAmountRow(index) {
      if (this.fastAmountRows.length > 1) {
        this.fastAmountRows.splice(index, 1)
      }
    },
    buildFastAmountList() {
      const validRows = this.fastAmountRows.filter(row => row.discountAmount > 0 && row.faceAmount > 0)
      return validRows.map(row => `${row.faceAmount}:${row.discountAmount}`).join(',')
    },
    buildAmountList() {
      const validRows = this.amountRows.filter(row => row.discountAmount > 0 && row.faceAmount > 0)
      return validRows.map(row => `${row.faceAmount}:${row.discountAmount}`).join(',')
    },
    validateAmountRows() {
      const invalidRows = this.amountRows.filter(row => {
        const discountAmount = Number(row.discountAmount)
        const faceAmount = Number(row.faceAmount)
        return (discountAmount > 0 && faceAmount <= 0) || (faceAmount > 0 && discountAmount <= 0)
      })
      if (invalidRows.length > 0) {
        this.$message.error(this.$t('editRechargeSetting.amountValidationError'))
        return false
      }
      const validRows = this.amountRows.filter(row => row.discountAmount > 0 && row.faceAmount > 0)
      if (validRows.length === 0) {
        this.$message.error(this.$t('editRechargeSetting.amountRequired'))
        return false
      }
      return true
    },
    save() {
      if (!this.validateAmountRows()) {
        return
      }
      this.editRechargeSettingForm.amountList = this.buildAmountList()
      this.editRechargeSettingForm.fastAmountList = this.buildFastAmountList()
      updateRechargeSetting(this.editRechargeSettingForm)
        .then(response => {
          if (response.code === '0') {
            this.$message.success(this.$t('editRechargeSetting.updateSuccess'))
            this.close()
            this.$emit('refresh')
          } else {
            this.$message.error(response.msg || this.$t('editRechargeSetting.updateFailed'))
          }
        })
        .catch(error => {
          console.error('更新失败:', error)
          this.$message.error(this.$t('editRechargeSetting.updateFailed'))
        })
    }
  }
}
</script>

<style scoped>
.edit-form {
  margin-top: 10px;
}
.amount-list-container {
  max-height: 300px;
  overflow-y: auto;
}
.amount-tip {
  margin-top: 10px;
  color: #999;
  font-size: 12px;
}
</style>